import { render, staticRenderFns } from "./img-header.vue?vue&type=template&id=1dad2a4e&scoped=true&"
import script from "./img-header.vue?vue&type=script&lang=js&"
export * from "./img-header.vue?vue&type=script&lang=js&"
import style0 from "./img-header.vue?vue&type=style&index=0&id=1dad2a4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dad2a4e",
  null
  
)

export default component.exports